<template>
  <div id="pageRoot">
    <template v-if="!$route.meta.public">
      <v-app>
        <left-side-bar class="app--drawer"/>
        <right-side-bar class="app--drawer"/>
        <app-toolbar class="app--toolbar"/>
        <v-content style="background-color:#FFF">
          <div class="page-wrapper" style="background-color:#fff">
            <!-- Loading page -->
            <v-progress-linear :indeterminate="true" v-show="showLoading"></v-progress-linear>
            <!-- Alert -->
            <alert-component class="ma-2"/>
            <v-alert
              class="ma-2"
              v-show="!isVerify"
              :value="true"
              color="warning"
              icon="priority_high"
              outline
            >Your Account is not verify. Please Check Your Email</v-alert>
            <!-- Content -->
            <router-view/>
          </div>
        </v-content>
      </v-app>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view/>
        </keep-alive>
      </transition>
    </template>
  </div>
</template>

<script>
/* eslint-disable */
import LeftSideBar from "@/components/master/drawers/LeftSideDrawer";
import RightSideBar from "@/components/master/drawers/RightSideDrawer";
import AlertComponent from "@/components/AlertComponent";
import AppToolbar from "@/components/AppToolbar2";
import AppEvents from "@/event";
import SettingService from "@/services/SettingService";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  data: () => ({
    showlayout: false,
    currentLang: {},
    languages: [],
    alert_data: {
      status: true,
      type: String,
      message: String
    },
    isVerify: false
  }),
  components: {
    AppToolbar,
    LeftSideBar,
    RightSideBar,
    AlertComponent
  },
  computed: {
    ...mapState("app", [
      "showLoading",
      "formatDates",
      "symbolStyles",
      "currencySymbols"
    ])
  },
  methods: {
    ...mapActions("app", ["commitGeneralSetting"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),
    getGeneralSetting() {
      let _token = localStorage._token;
      let _company_guid = localStorage._company_guid;
      if (
        this.formatDates == "" &&
        this.symbolStyles == "" &&
        this.currencySymbols == "" &&
        _token != undefined &&
        _company_guid != undefined
      ) {
        SettingService.getGeneralSetting()
          .then(res => {
            if (res.data.content.length > 0) {
              let format_date =
                res.data.content[0].format_date != null
                  ? res.data.content[0].format_date.toString()
                  : "1";
              let symbol_styles =
                res.data.content[0].currency_symbols != null
                  ? res.data.content[0].currency_symbols.toString()
                  : "บาท";
              let currency_symbols =
                res.data.content[0].symbols_style != null
                  ? res.data.content[0].symbols_style.toString()
                  : "1";
              this.commitGeneralSetting({
                format_date: format_date,
                symbol_styles: symbol_styles,
                currency_symbols: currency_symbols
              });
            }
          })
          .catch(err => {
            this.commitToggleAlertDialog({
              status: true,
              message: err.response.data
            });
          });
      }
    },
    checkVerify() {
      console.log(localStorage._verify);

      if (localStorage._verify === undefined) {
        this.isVerify = false;
      } else {
        this.isVerify = localStorage._verify;
      }
    },
    initLang() {
      for (let langKey in this.$i18n.messages) {
        this.languages[this.languages.length] = {
          code: langKey,
          title: this.$i18n.messages[langKey].lang
        };
      }

      if (localStorage.getItem("lang")) {
        this.$i18n.locale = localStorage.getItem("lang");
      }
      this.currentLang = this.$i18n.locale;
    }
  },
  created() {
    AppEvents.forEach(item => {
      this.$on(item.name, item.callback);
    });
    window.getApp = this;
    this.checkVerify();
    this.getGeneralSetting();
    this.initLang();
  }
};
</script>
<style>
.adddoc-hover:hover {
  transition: transform 0.3s;
  transform: scale(1.15);
}
.v-progress-linear {
  margin-top: 0px;
  margin-bottom: 0px;
}
</style>
